"use strict";

var _toConsumableArray = require("/Users/topedaramola/Documents/Client Work/UtterFun/utter/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _classCallCheck = require("/Users/topedaramola/Documents/Client Work/UtterFun/utter/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/topedaramola/Documents/Client Work/UtterFun/utter/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isBrowser = typeof window !== 'undefined';

function last(arr) {
  return arr[arr.length - 1];
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }

  for (var i = 0; i < document.styleSheets.length; i += 1) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }

  return;
}

function makeStyleTag() {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-ui-box', '');
  tag.append(document.createTextNode(''));
  (document.head || document.querySelector('head')).append(tag);
  return tag;
}

var CustomStyleSheet = /*#__PURE__*/function () {
  function CustomStyleSheet() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CustomStyleSheet);

    this.tags = [];
    this.ctr = 0;
    this.injected = false;
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.maxLength = options.maxLength || 65000;
  }

  _createClass(CustomStyleSheet, [{
    key: "getSheet",
    value: function getSheet() {
      return sheetForTag(last(this.tags));
    }
  }, {
    key: "inject",
    value: function inject() {
      var _this = this;

      if (this.injected) {
        throw new Error('StyleSheet has already been injected.');
      }

      if (isBrowser) {
        this.tags[0] = makeStyleTag();
      } else {
        this.sheet = {
          cssRules: [],
          insertRule: function insertRule(rule) {
            _this.sheet.cssRules.push({
              cssText: rule
            });
          }
        };
      }

      this.injected = true;
    }
  }, {
    key: "speedy",
    value: function speedy(bool) {
      if (this.ctr !== 0) {
        throw new Error("StyleSheet cannot change speedy mode after inserting any rule to sheet. Either call speedy(".concat(bool, ") earlier in your app, or call flush() before speedy(").concat(bool, ")"));
      }

      this.isSpeedy = Boolean(bool);
    }
  }, {
    key: "_insert",
    value: function _insert(sheet, rule) {
      sheet.insertRule(rule, sheet.cssRules.length);
    }
  }, {
    key: "insert",
    value: function insert(rule) {
      if (isBrowser) {
        var sheet = this.getSheet();

        if (this.isSpeedy && sheet && sheet.insertRule) {
          this._insert(sheet, rule);
        } else {
          last(this.tags).append(document.createTextNode(rule));
        }
      } else if (this.sheet) {
        this.sheet.insertRule(rule, this.sheet.cssRules.length);
      }

      this.ctr += 1;

      if (isBrowser && this.ctr % this.maxLength === 0) {
        this.tags.push(makeStyleTag());
      }

      return this.ctr - 1;
    }
  }, {
    key: "flush",
    value: function flush() {
      if (isBrowser) {
        this.tags.forEach(function (tag) {
          return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.sheet = null;
        this.ctr = 0;
      } else if (this.sheet) {
        this.sheet.cssRules = [];
      }

      this.injected = false;
    }
  }, {
    key: "rules",
    value: function rules() {
      if (!isBrowser) {
        return this.sheet ? this.sheet.cssRules : [];
      }

      var arr = [];
      this.tags.forEach(function (tag) {
        var sheet = sheetForTag(tag);

        if (sheet) {
          var rules = Array.from(sheet.cssRules);
          arr.splice.apply(arr, [arr.length, 0].concat(_toConsumableArray(rules)));
        }
      });
      return arr;
    }
  }]);

  return CustomStyleSheet;
}();

exports.default = CustomStyleSheet;